/* src/app/claim-contract/claim-contract-list/claim-contract-list.component.css */
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=claim-contract-list.component-I5PEDU3E.css.map */
